import { storage } from 'firebase/app';

export type UploadTask = storage.UploadTask;
export type UploadTaskSnapshot = storage.UploadTaskSnapshot;
export type UploadMetadata = storage.UploadMetadata;

export type SettableMetadata = storage.SettableMetadata;
export type Reference = storage.Reference;
export type StringFormat = storage.StringFormat;